<div class="app-shell">
  <aside class="sidebar">
    <div class="brand">
      <div class="brand__mark">
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M12 21V10m0 0C9.5 7 6.5 6 3 7c.5 4 3.5 6 9 3Zm0 0c2.5-3 5.5-4 9-3-.5 4-3.5 6-9 3Z"
          />
        </svg>
      </div>

      <div class="brand__text">
        <strong>FarmField</strong>
        <span>Planner</span>
      </div>
    </div>

    <nav class="navigation">
      <a
        routerLink="/"
        routerLinkActive="navigation__item--active"
        [routerLinkActiveOptions]="{ exact: true }"
        class="navigation__item"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path
            d="M3 13h8V3H3v10Zm0 8h8v-6H3v6Zm10 0h8V11h-8v10Zm0-18v6h8V3h-8Z"
          />
        </svg>

        <span>{{ i18n.t('nav.dashboard') }}</span>
      </a>

      <a
        routerLink="/fields"
        routerLinkActive="navigation__item--active"
        class="navigation__item"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 20V10m5 10V4m6 16v-7m5 7V7" />
        </svg>

        <span>{{ i18n.t('nav.fields') }}</span>
      </a>

      <a
        routerLink="/planning"
        routerLinkActive="navigation__item--active"
        class="navigation__item"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect
            x="3"
            y="5"
            width="18"
            height="16"
            rx="2"
          />
          <path d="M16 3v4M8 3v4M3 11h18" />
        </svg>

        <span>{{ i18n.t('nav.planning') }}</span>
      </a>

      <a
        routerLink="/calendar"
        routerLinkActive="navigation__item--active"
        class="navigation__item"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <rect
            x="3"
            y="5"
            width="18"
            height="16"
            rx="2"
          />
          <path d="M16 3v4M8 3v4M3 11h18M7 15h2M11 15h2M15 15h2" />
        </svg>

        <span>{{ i18n.t('nav.calendar') }}</span>
      </a>

      <a
        routerLink="/statistics"
        routerLinkActive="navigation__item--active"
        class="navigation__item"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M4 20V10m6 10V4m6 16v-7m4 7H2" />
        </svg>

        <span>{{ i18n.t('nav.statistics') }}</span>
      </a>
    </nav>

    <div class="sidebar__footer">
      <div class="server-status">
        <span class="server-status__indicator"></span>

        <div>
          <strong>
            {{ i18n.t('shell.gameServer') }}
          </strong>
          <span>
            {{ i18n.t('shell.connected') }}
          </span>
        </div>
      </div>
    </div>
  </aside>

  <div class="workspace">
    <header class="topbar">
      <div class="topbar__title">
        <span>
          {{ i18n.t('shell.farmOverview') }}
        </span>
        <strong>
          {{ i18n.t('shell.goodMorning') }}
        </strong>
      </div>

      <div class="topbar__actions">
        @if (
          activeGameServerService.loading()
          ) {
          <div
            class="farm-selector farm-selector--loading"
          >
            Server werden geladen ...
          </div>
        } @else if (
          activeGameServerService.error()
          ) {
          <div
            class="farm-selector farm-selector--error"
          >
            Server konnten nicht geladen werden
          </div>
        } @else if (
          activeGameServerService
            .gameServers()
            .length > 0
          ) {
          <div class="farm-selector">
            <label for="active-game-server">
              Server
            </label>

            <select
              id="active-game-server"
              [value]="
          activeGameServerService
            .activeGameServerId() ?? ''
        "
              (change)="
          selectGameServer(
            $any($event.target).value
          )
        "
            >
              @for (
                gameServer of
                  activeGameServerService
                    .gameServers();
                track gameServer.id
                ) {
                <option
                  [value]="gameServer.id"
                >
                  {{ gameServer.name }}
                </option>
              }
            </select>
          </div>
        }

        @if (
          activeFarmService.loading()
          ) {
          <div
            class="farm-selector farm-selector--loading"
          >
            HÃ¶fe werden geladen ...
          </div>
        } @else if (
          activeFarmService.error()
          ) {
          <div
            class="farm-selector farm-selector--error"
          >
            HÃ¶fe konnten nicht geladen werden
          </div>
        } @else if (
          activeFarmService.farms().length > 0
          ) {
          <div class="farm-selector">
            <label for="active-farm">
              Hof
            </label>

            <select
              id="active-farm"
              [value]="
          activeFarmService.activeFarmId() ?? ''
        "
              (change)="
          selectFarm(
            $any($event.target).value
          )
        "
            >
              @for (
                farm of activeFarmService.farms();
                track farm.id
                ) {
                <option [value]="farm.id">
                  {{ farm.name }}
                </option>
              }
            </select>
          </div>
        }

        <app-language-switcher />

        <div
          class="sync-status"
          [class.sync-status--error]="hasSyncError()"
        >
          <span
            class="sync-status__indicator"
          ></span>
          <span>
            {{
              hasSyncError()
                ? i18n.t('shell.syncError')
                : i18n.t('shell.synced')
            }}
          </span>

          @if (hasSyncError() && syncErrorMessageKey()) {
            <button
              class="sync-status__info"
              type="button"
              [attr.aria-label]="i18n.t('shell.syncError.title')"
              [attr.title]="i18n.t('shell.syncError.title')"
              (click)="openSyncError()"
            >
              i
            </button>
          }
        </div>

        <!--
          <button
            class="profile"
            type="button"
            aria-label="Profile"
          >
            ML
          </button>
        -->
      </div>
    </header>

    <main class="content">
      <router-outlet />
    </main>
  </div>

  <app-dialog
    [open]="syncErrorOpen()"
    [title]="i18n.t('shell.syncError.title')"
    tone="warning"
    (closed)="closeSyncError()"
  >
    @if (syncErrorMessageKey(); as messageKey) {
      <p class="sync-error-dialog__message">
        {{ i18n.t(messageKey) }}
      </p>
    }

    @if (syncErrorStatus(); as status) {
      <p class="sync-error-dialog__status">
        {{ i18n.t('shell.syncError.httpStatus') }}: {{ status }}
      </p>
    }
  </app-dialog>

  <nav class="mobile-navigation">
    <a
      routerLink="/"
      routerLinkActive="mobile-navigation__item--active"
      [routerLinkActiveOptions]="{ exact: true }"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path
          d="M3 13h8V3H3v10Zm0 8h8v-6H3v6Zm10 0h8V11h-8v10Zm0-18v6h8V3h-8Z"
        />
      </svg>

      <span>
        {{ i18n.t('nav.dashboard') }}
      </span>
    </a>

    <a
      routerLink="/fields"
      routerLinkActive="mobile-navigation__item--active"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 20V10m5 10V4m6 16v-7m5 7V7" />
      </svg>

      <span>
        {{ i18n.t('nav.fields') }}
      </span>
    </a>

    <a
      routerLink="/planning"
      routerLinkActive="mobile-navigation__item--active"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect
          x="3"
          y="5"
          width="18"
          height="16"
          rx="2"
        />
        <path d="M16 3v4M8 3v4M3 11h18" />
      </svg>

      <span>
        {{ i18n.t('nav.planning') }}
      </span>
    </a>

    <a
      routerLink="/calendar"
      routerLinkActive="mobile-navigation__item--active"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <rect
          x="3"
          y="5"
          width="18"
          height="16"
          rx="2"
        />
        <path d="M16 3v4M8 3v4M3 11h18M7 15h2M11 15h2M15 15h2" />
      </svg>

      <span>
        {{ i18n.t('nav.calendar') }}
      </span>
    </a>

    <a
      routerLink="/statistics"
      routerLinkActive="mobile-navigation__item--active"
    >
      <svg viewBox="0 0 24 24" aria-hidden="true">
        <path d="M4 20V10m6 10V4m6 16v-7m4 7H2" />
      </svg>

      <span>
        {{ i18n.t('nav.statistics') }}
      </span>
    </a>
  </nav>
</div>
